export default {
  // 防抖
  debounce: function (fn, t) {
      let delay = t || 500;
      let timer;
      return function () {
        let th = this;
        let args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          timer = null;
          fn.apply(th, args);
        }, delay);
      }
    },
    // 节流
    throttle: function (fn, t) {
      let last;
      let timer;
      let interval = t || 500;
      return function () {
        let th = this;
        let args = arguments;
        let now = +new Date();
        if (last && now - last < interval) {
          clearTimeout(timer);
          timer = setTimeout(function () {
            last = now;
            fn.apply(th, args);
          }, interval);
        } else {
          last = now;
          fn.apply(th, args);
        }
      }
    }
}
  

